import { PROMO_NAMES, TPromoName } from './PromoModal.types';

export function isPromoName(value: any): value is TPromoName {
  return PROMO_NAMES.includes(value as TPromoName);
}
